export default "__VITE_ASSET__Cn0WAkJZ__"